/*
 * Copyright (c) 2016-2018 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Component, Input} from '@angular/core';

import {ColumnToggleButtons, ColumnToggleButtonsService} from './providers/column-toggle-buttons.service';
export class DatagridColumnToggleButton {
     clrType: ColumnToggleButtons;
/**
 * @param {?} toggleButtons
 */
constructor(public toggleButtons: ColumnToggleButtonsService) {}
/**
 * @return {?}
 */
getClasses() {
        let /** @type {?} */ classes = "btn ";
        if (this.isOk()) {
            classes += "btn-primary";
        } else {
            classes += "btn-sm btn-link p6 text-uppercase";
        }
        return classes;
    }
/**
 * @return {?}
 */
isOk() {
        return this.clrType === "ok";
    }
/**
 * @return {?}
 */
click() {
        this.toggleButtons.buttonClicked(this.clrType);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-dg-column-toggle-button",
    template: `
        <button
            (click)="click()"
            [disabled]="toggleButtons.selectAllDisabled && !isOk()"
            [ngClass]="getClasses()"
            type="button">
            <ng-content></ng-content>
        </button>
    `,
    host: {"[class.action-right]": "isOk()", "[style.display]": "block"}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ColumnToggleButtonsService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'clrType': [{ type: Input },],
};
}

function DatagridColumnToggleButton_tsickle_Closure_declarations() {
/** @type {?} */
DatagridColumnToggleButton.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatagridColumnToggleButton.ctorParameters;
/** @type {?} */
DatagridColumnToggleButton.propDecorators;
/** @type {?} */
DatagridColumnToggleButton.prototype.clrType;
/** @type {?} */
DatagridColumnToggleButton.prototype.toggleButtons;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
